// сообщения между потоками
export interface WorkerMessage {
  type: string
  payload: any
}

// is_dev фича-флаг
const isDevMode = (): boolean => {
  if (typeof window === 'undefined') return false
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('is_dev') === 'true'
}

// отправка сообщений в worker
export const sendToWorker = (message: WorkerMessage): void => {
  if (!isDevMode()) return
  console.log('Worker message sent:', message)

  // if (typeof window !== 'undefined' && window.partytown) {
  //   window.partytown.sendMessage(message)
  // }
}

// получение сообщений от worker
export const handleWorkerMessage = (callback: (message: WorkerMessage) => void): void => {
  if (!isDevMode()) return
  // в dev режиме просто логируем

  console.log('Worker message handler registered')
  // if (typeof window !== 'undefined' && window.partytown) {
  //   window.partytown.onMessage(callback)
  // }
}

// создание события
export const createCustomEvent = (name: string, detail: any): CustomEvent => {
  if (!isDevMode()) return
  return new CustomEvent(name, {
    detail,
    bubbles: true,
    cancelable: true,
  })
}

// отправка события
export const dispatchCustomEvent = (event: CustomEvent): void => {
  if (!isDevMode()) return
  if (typeof window !== 'undefined') {
    window.dispatchEvent(event)
  }
}
